import { useState } from "react";
import styles from "./ModelsHistoryView.module.scss";
import { View, ViewHeader } from "@/components";
import type {
  ModelsHistoryPeriodFilter,
  ModelsHistoryScopeFilter,
  ModelsHistoryToolbarTab,
} from "../../_constants/models-history-toolbar.const";
import { ModelsHistoryToolbar } from "../models-history-toolbar";

export const ModelsHistoryView = () => {
  const [tab, setTab] = useState<ModelsHistoryToolbarTab>("all");
  const [period, setPeriod] = useState<ModelsHistoryPeriodFilter>("all");
  const [scope, setScope] = useState<ModelsHistoryScopeFilter>("all");

  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="History"
          description="Audit trail for model versions, approvals, and publishes.<br />Filter by activity type and time range, then export when you need a record."
        />

        <ModelsHistoryToolbar
          tab={tab}
          period={period}
          scope={scope}
          onTabChange={setTab}
          onPeriodChange={setPeriod}
          onScopeChange={setScope}
          onExportClick={() => undefined}
        />

        <p className={styles["comp__empty"]}>No history yet.</p>
      </div>
    </View>
  );
};
